import React from 'react'

import blackHands from '../../images/BLACK-HANDS.png'
import blackHands6 from '../../images/BLACK HANDS 6..png'

function BlackHands() {
  return (
    <div className="Project-page container">
      <div className="row">
        <div className="col-md-6">
          <img
            src={blackHands}
            className="project-image" />
          <img
            src={blackHands6}
            className="project-image" />
        </div>
        <div className="Project-content col-md-6">
          <h1>Black Hands</h1>
          <p className="Project-text">
            <strong>Television Series
              <br />
Warner Bros + TVNZ
              <br />
Director: David Stubbs
              <br />
              2020
              <br />
              <br />
            - nominated Best Drama NZ Television Awards 2021
              <br />
              <br />

Rehearsal + On Set Acting Coach
              <br />
Coached 4 of the core cast (ages 15, 18, 21, 22)

            </strong>
          </p>
                    <p className="Project-testimonial">
            "
            Ella played a huge part in turning our little ensemble into a family. Turning strangers into siblings.  Behind the scenes and often on-set too, Ella was a trusted collaborator allowing me to trust the young cast members were always prepared, connected and feeling safe as they headed into the murky territory of portraying members of one of New Zealand’s most controversial families. 
”
          </p>
          <h6 className="Testimonial-person">
            <strong>~David Stubbs, Director
</strong>
          </h6>
          <p className="Project-testimonial">
            "
I just wanted to say thank you so much for all your positivity and support today on set. You made the experience so wonderful and safe and I really really appreciate all the effort you put in. Thank you so much for doing an amazing job!
”
          </p>
          <h6 className="Testimonial-person">
            <strong>~Lucy Curry, actor - Arawa Bain
</strong>
          </h6>
        </div>
      </div>
    </div>
  )
}

export default BlackHands
